// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g3LG","right":"styles_right__WbwHX"};